module.exports = __webpack_public_path__ + "img/2.500bf064.jpg";